export default __webpack_public_path__ + "static/media/IMG_346.4e38dd65.jpg";